// extracted by mini-css-extract-plugin
export default {"storeactionblog":"f4a6d893b332e06932c7"};